<template>
  <div class="margin-top-dollar">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="flex-content">
        <div class="">
          <div :class="{'form-half':!isFina} ">
            <code-select
              v-if="formData.use_code!=0||isFina"
              :orderId="orderId"
              :notApply="true"
              :isQuote="false"
              :customerId="customerId"
              :customer="formData.customer"
              :is-user="true"
              :is-fina="isFina"
              :useCode = "formData.use_code"
              @check-code="applyCode"
            ></code-select>
            <div
              v-if="showReferralSelect&&!isFina"
              class="mg-t-20 mg-b-15 flex">
              <!--      <span class="fs-14 color-dark fw-600 title margin-left">Referrer Discount</span>-->
              <v-select
                v-model="referral_id"
                :list="referral_option_list"
                @change="handlerComputed"></v-select>
              <v-button
                gray
                class="mg-l-10"
                @click="handleInitRefer">Default</v-button>
            </div>
          </div>
        </div>
        <div class="flex-box">
          <div
            v-for="(item, index) in showSidebarPremium"
            :key="'side_'+index"
            class="flex-info">
            <span>{{ item.item }}</span>
            <span>{{ item.premium_str }}</span>
          </div>
          <!--          <div-->
          <!--            v-if="isFina"-->
          <!--            class="flex-info">-->
          <!--            <span>MGM Discount</span>-->
          <!--            <el-form-item-->
          <!--              ref="code_disc_prm"-->
          <!--              prop="code_disc_prm">-->
          <!--              <span>-->
          <!--                <v-input-->
          <!--                  v-model.number="formData.code_disc_prm"-->
          <!--                  prepend="-$"-->
          <!--                  :keyFloatNumber="true"-->
          <!--                  maxlength="8"-->
          <!--                  :min="0"-->
          <!--                  @blur="handlerComputed"></v-input>-->
          <!--              </span>-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <div class="flex-info">
            <span>Manual Discount </span>
            <el-form-item
              ref="spec_disc_prm"
              prop="spec_disc_prm">
              <span>
                <v-input
                  v-model.number="formData.spec_disc_prm"
                  prepend="-$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div  class="flex-info">
            <span>Insurer Admin Charge</span>
            <el-form-item
              ref="insurer_handling_fee"
              prop="insurer_handling_fee">
              <span>
                <v-input
                  v-model.number="formData.insurer_handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div  class="flex-info">
            <span>Agency Admin Charge</span>
            <el-form-item
              ref="agency_handling_fee"
              prop="agency_handling_fee">
              <span>
                <v-input
                  v-model.number="formData.agency_handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div  class="flex-info">
            <span>Total Admin Charge</span>
            <el-form-item
              ref="handling_fee"
              prop="handling_fee">
              <span>
                <v-input
                  v-model.number="formData.handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  disabled
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div
            v-if="referrer_is_special"
            class="flex-info">
            <span>Referrer discount</span>
            <el-form-item
              ref="code_disc_prm"
              prop="code_disc_prm">
              <span>
                <v-input
                  v-model.number="formData.code_disc_prm"
                  prepend="-$"
                  :keyFloatNumber="true"
                  :max="max_code_disc_prm"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div
            class="flex-info total-amount">
            <span>{{amountResult.item}}</span>
            <span class="amount">{{ amountResult.premium_str }}</span>
          </div>
        </div>
        <span class="block mg-b-20 fs-16 color-dark fw-600 mg-t-20">Commission Settings</span>
        <div class="flex-box">
          <div
            v-for="(item, index) in commission"
            :key="'commission_'+index">
            <el-form-item
              :ref="item.name"
              :rules="item.name=='referrer_net'?rules.referrer_net:[]"
              :prop="item.name">
              <div
                :class="{'total-amount':['earning'].includes(item.name),'flex-info':!['referrer_net','insurer_net'].includes(item.name),'border-bottom-0':['referrer_net'].includes(item.name)}"
              >
                <template v-if="!['referrer_net','insurer_net'].includes(item.name)">
                  <span>{{ item.item }}</span>
                  <template >
                    <span  :class="{'amount':['earning'].includes(item.name)}">{{ item.premium_str }}</span>
                  </template>
                </template>
                <template v-else>

                  <div class="flex-info">
                    <span >{{item.name=='referrer_net'?'Referrer Reward(Commission) Rate':'Insurer Commission Rate'}}</span>
                    <span
                      v-if="['referrer_net','insurer_net'].includes(item.name)"
                      class="flex flex-align-center mg-r-15">
                      <v-input
                        v-model.number="formData[`${item.name}_pct`]"
                        append="%"
                        :keyFloatNumber="true"
                        :key-float-count="4"
                        :min="0"
                        @blur="handlerComputed"></v-input>
                    </span>
                  </div>
                  <div
                    v-if="item.name=='insurer_net'"
                    class="flex-info">
                    <span>{{item.name=='referrer_net'?'Referrer Net(with levy)':'Insurer Net(with levy)'}}</span>
                    <span>{{item.premium_str}}</span>
                  </div>
                </template>
              </div>
            </el-form-item>
          </div>
        </div>

      </div>
    </el-form>
    <!--    <coupon-dialog-->
    <!--      ref="coupon-dialog"-->
    <!--      :customerId="customerId"-->
    <!--      :customer="formData.customer"-->
    <!--      :orderId="orderId"-->
    <!--      @coupon="computedCoupon">-->
    <!--    </coupon-dialog>-->
  </div>
</template>

<script>

import CodeSelect from '@/views/components/code-select'
import CouponDialog from '@/views/quoting/dialogs/coupon-dialog'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import {applyOrderCode, verifyPromoCode} from '@api/order'
import {mapActions} from 'vuex'
import MixinRules from '@/mixins/rules'
import MixinReferralOption from '@/mixins/referral-option'
import {checkEmail} from '@/utils/validate'
export default {
  name: 'SmePremium',
  components:{
    CodeSelect,
  },
  mixins: [MixinOptions, MixinFormat,MixinRules,MixinReferralOption],
  props:{
    sidebarInfo:{
      type: Object,
      default:()=>({})
    },
    form:{
      type: Object,
      default:()=>({})
    },
    premium:{
      type: Array,
      default:()=>([])
    },
    commission:{
      type: Array,
      default:()=>([])
    },
    customerId:{
      type: Number,
      default:''
    },
    orderId:{
      type: Number,
      default:''
    },
    isFina:{
      type:Boolean,
      default:false
    },
    isFirst:{
      type:Boolean,
      default:false
    },
    isDefaultReferrerPct:{
      type:Boolean,
      default:false
    }
  },
  data(){
    const checkReferrerNetPrm = (rule, value, callback) => {
      let {referrer_net_prm,referrer_net_type} = this.formData||{}
      if(Number(referrer_net_prm)>this.commission_gross_prm&&Number(referrer_net_type)==2){
        callback(new Error('Cannot exceed the Gross Premium.'))
      }
      callback()
    }
    return{
      amount: '',
      is_first:true,
      formData:{
        spec_disc_prm:'',
        handling_fee:'',
        agency_handling_fee:0,
        insurer_handling_fee:0,
        code:'',
        coupon_code:'',
        amount:'',
        payable:'',
        referrer_net_type:1,
        referrer_net_pct:0,
        insurer_net_pct:0,
        // referrer_net_prm:0,
        code_disc_prm:'',
      },
      premium_info:[],
      rules:{
        referrer_net: [
          { validator: checkReferrerNetPrm, trigger: ['change', 'blur'] },
        ],
      }
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode','selectCode']),
    referrer_is_special(){
      let {referrer_is_special} = this.form||{}
      return referrer_is_special
    },
    max_code_disc_prm(){
      let {max_code_disc_prm} = this.form||{}
      return max_code_disc_prm
    },
    package_name(){
      let {package_info={}} = this.sidebarInfo
      let {package_name=''} = package_info
      return package_name
    },
    amountResult() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'paid') {
          total = item||{}
        }
      })
      return total||{}
    },
    handling_fee() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'handling_fee') {
          total = item||{}
        }
      })
      return total||{}
    },
    insurer_handling_fee() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'insurer_handling_fee') {
          total = item||{}
        }
      })
      return total||{}
    },
    agency_handling_fee() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'agency_handling_fee') {
          total = item||{}
        }
      })
      return total||{}
    },
    spec_disc_prm() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'spec_disc_prm') {
          total = item||{}
        }
      })
      return total||{}
    },
    code_disc_prm() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'code_disc_prm') {
          total = item||{}
        }
      })
      return total||{}
    },
    plan_info(){
      let {premium_info} = this.sidebarInfo||{}
      return premium_info||{}
    },
    sidebarPremium() {
      return this.premium||[]
    },
    showSidebarPremium(){
      let arr = this.sidebarPremium.filter(item=>{
        if(!this.referrer_is_special)
          return !['agency_handling_fee','insurer_handling_fee','spec_disc_prm','paid','handling_fee'].includes(item.name)
        // return item.name!='spec_disc_prm'&&item.name!='coupon_vl'&&item.name!='paid'&&item.name!='handling_fee'
        return !['agency_handling_fee','insurer_handling_fee','code_disc_prm','coupon_vl','spec_disc_prm','paid','handling_fee'].includes(item.name)
        // return item.name!='code_disc_prm'&&item.name!='spec_disc_prm'&&item.name!='coupon_vl'&&item.name!='paid'&&item.name!='handling_fee'
      })
      return arr||[]
    },
    commission_gross_prm() {
      let total = {}
      this.commission.filter((item)=>{
        if(item.name == 'gross') {
          total = item||{}
        }
      })
      return total.premium||{}
    }
  },
  watch:{
    form:{
      immediate:true,
      deep:true,
      handler(val){
        if(val){
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] =val[key]
            }
          })
          let {referrer_net_type} = val||{}
          this.formData.referrer_net_type = 1
          let {commission} = val||[]
          commission.forEach(item => {
            if (item.name !== 'gross') {
              this.formData[`${item.name}_pct`] = item.pct || 0
              // this.formData[`${item.name}_prm`] = item.premium || 0;
            }
          })
          let {referrer_net_pct} = this.formData||{}
          this.$nextTick(()=>{
            if(this.isDefaultReferrerPct&&referrer_net_pct<=0&&this.is_first){
              this.formData.referrer_net_pct = 10
            }
          })
          console.log('----',this.formData)
        }
      }
    },
    // handling_fee:{
    //   immediate:true,
    //   deep:true,
    //   handler(val){
    //     let {premium} = val||{}
    //     this.formData.handling_fee =premium||0
    //     this.$emit('getFormData', this.formData)
    //   }
    // },
    // spec_disc_prm:{
    //   immediate:true,
    //   deep:true,
    //   handler(val){
    //     let {premium} = val||{}
    //     this.formData.spec_disc_prm =premium||0
    //     this.$emit('getFormData', this.formData)
    //   }
    // },
    // code_disc_prm:{
    //   immediate:true,
    //   deep:true,
    //   handler(val){
    //     let {premium} = val||{}
    //     this.formData.code_disc_prm =premium||0
    //     this.$emit('getFormData', this.formData)
    //   }
    // },
    'formData.payable':{
      immediate:true,
      handler(val){
        this.$emit('update:amount',val)
      }
    }
  },
  methods:{
    ...mapActions('coupon', ['setSelectCode']),
    handleInitRefer(){
      if(this.isFina) return
      this.initReferrerId()
      this.handlerComputed()
    },
    handlerComputed(){
      this.is_first = false
      let params = {...this.formData}
      this.$refs.form.validate(valid => {
        if(valid) {
          this.$emit('cal',params)
        }
      })
    },
    applyCode(){
      this.network().verifyPromoCode()
    },
    computedCoupon(data){
      this.coupon = data
      this.formData.coupon = data
      this.applyCode()
    },
    handlerSetCode(){
      let {campaign_code,code,coupon_code,referrer, referrer_user_id} = this.form
      let params ={}
      // this.setSelectCode(null)
      if(coupon_code){
        params.coupon = {title:coupon_code,coupon_code}
        // this.setSelectCode ({selectCode:1,...coupon})
      }
      if(campaign_code){
        params.coupon = {title:campaign_code,campaign_code}
        params.is_campaign_code =1
      }
      let {detail={}} = referrer||{}
      if(code||this.isFina&&detail.code){
        params.code = {code:this.isFina?detail.code:code, referrer:this.isFina?detail:referrer, referrer_user_id}
      }
      this.setSelectCode(params)
    },
    network(){
      return {
        verifyPromoCode: async () => {
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.customerId,
              code: this.code
            })
            if (data.code == 1000) {
              this.network().applyOrderCode()
            }
          } else {
            this.network().applyOrderCode()
          }

        },
        applyOrderCode: async () => {
          let {selectCode, coupon = {}, code = {},is_campaign_code} = this.selectCode || {}
          let params = {}
          params.coupon_code = coupon.coupon_code
          params.code = code.code
          if(is_campaign_code)
          {
            params.campaign_code = coupon.coupon_code
            params.coupon_code = null
          }
          const {dataCode} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            ...params
          })

          this.formData.code = params.code
          this.formData.coupon_code = params.coupon_code
          if(is_campaign_code)
          {
            this.formData.campaign_code = params.coupon_code
            this.formData.coupon_code = null
          }
          this.formData = {
            ...this.formData,
            ...params
          }
          this.$emit('cal',this.formData)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.margin-top-dollar{
  .flex-algin{
    //align-items: center;
    margin-bottom: 10px;
    width: 100%;
    .label{
      margin-top: 0;
      word-break: break-word;
    }
    .icon{
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
  }
  .flex-content {
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      //margin: 16px 0;
      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 8px 15px;
        border-bottom: 1px solid #E1E4E8;
        &.border-bottom-0{
          //border-bottom: 0;
        }
        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight:600;
          width: 50%;
          &.width-40{
            width: 40%;
          }
        }
        span:last-child {
          color: #24292E;
          font-size: 14px;
          font-weight:400;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
        padding: 20px 15px;
        span{
          font-weight: 600!important;
        }
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
  }
  .just-end{
    display: flex;
    justify-content: flex-end;
  }
}
/deep/ .el-input-group__append {
  padding: 0 12px;
  //background: #fff;
}
/deep/.el-form-item__error{
  top: 70%;
  left: 15px;
}
</style>
